import { Component, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';
import * as moment from 'moment';
import { AddCall } from 'src/providers/addvCall';

@Component({
  selector: 'app-vaccinepopup',
  templateUrl: './vaccinepopup.page.html',
  styleUrls: ['./vaccinepopup.page.scss'],
})
export class VaccinepopupPage implements OnInit {

  VaccinationReminderstatus: any;
  VaccinationSuccessstatus: any;
  VaccinationRemindermsg: any;
  VaccinationReminder: boolean = false;
  VaccinationSuccess: boolean = false;
  VaccinationAlert: boolean = false;
  ProfileDeletes: boolean = false;
  name: any;
  Date: any;
  data: any;
  gender: any;
  msg: any;
  ProfileDelete:any;
  constructor(
    public modalCtrl: ModalController,
    public addCall: AddCall
  ) { }

  ngOnInit() {}
  ionViewWillEnter() {
    debugger;
    this.VaccinationReminder = false;
    this.VaccinationSuccess = false;
    this.VaccinationAlert = false;
    this.ProfileDeletes=false;
    console.log('name',this.name,'date',this.Date);
    console.log(this.data);
    console.log(this.gender,"gender");
    
    if(this.VaccinationReminderstatus == 1){
      this.name = this.data.childName;;
      this.Date =  moment(this.data.date_of_injection).format('DD-MMM-YY');
      this.VaccinationReminder = true;
    }else if (this.VaccinationSuccessstatus == 1){
      this.gender =  this.gender.toUpperCase();
      console.log(this.gender);
      this.VaccinationSuccess = true;
      // this.gender = localStorage.getItem("Gender")
    }else if (this.VaccinationSuccessstatus == 0){
      console.log(this.msg );
      this.VaccinationAlert = true;
    }else if (this.ProfileDelete == 1){
      this.ProfileDeletes=true;
    }
  }

  onclose(id){
    this.modalCtrl.dismiss(id);
  }
  oncloses(){
    this.modalCtrl.dismiss();
  }
  delete(type){
      this.modalCtrl.dismiss(type);
  }
}
